import { CaseProjection } from '../../../../../projection/cases/CaseProjection';

export const getCaseDataProjectedTopLevelCount = (caseProjection: CaseProjection): number =>
  caseProjection.projectedTopLevelsCount;
